import * as React from 'react';
/**
 *
 * Original name: syncing
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=20530%3A2414
 *
 */
export const SyncingSync = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M12 4c-5.159 0-8 2.841-8 8s2.841 8 8 8 8-2.841 8-8-2.841-8-8-8Z", fill: "#0061FF", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { d: "M16.75 11c-.148-.994-.532-1.848-1.181-2.498-.858-.858-2.074-1.252-3.498-1.252-1.65 0-3.006.535-3.846 1.654L7.192 7.869V11h3.129L9.303 9.982c.474-.76 1.347-1.232 2.768-1.232 1.156 0 1.94.316 2.437.813.338.338.592.808.72 1.437h1.522Zm-9.558 2c.148.994.532 1.848 1.181 2.498.858.858 2.074 1.252 3.497 1.252 1.652 0 3.007-.535 3.847-1.654l1.033 1.035V13h-3.13l1.019 1.018c-.474.76-1.347 1.232-2.769 1.232-1.155 0-1.94-.316-2.436-.813-.338-.337-.592-.808-.72-1.437H7.192Z", fill: "#fff", vectorEffect: "non-scaling-stroke" })));
